import { Anchor, Breadcrumbs, Grid, Tabs, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';
import EmailsClickAnalyticsPage from './EmailsClickAnalyticsPage';

const page = `${Page['email']}`;

const EmailsStatisticsPage = () => {
  const fetch = useFetch();

  const [email, setEmail] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, emailId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = ['clickAnalytics', 'statistics'];
  const search = queryString.parse(location.search);
  const tab = search.tab || tabs[0];
  const setTab = (tab) => {
    navigate(`${location.pathname}?${queryString.stringify({ ...search, tab, page: 1 })}`);
  };

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/emails/${emailId}`)
      .then(({ email }) => setEmail(email))
      .catch(setError);
  }, [accountId, domainId, emailId, fetch]);

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/emails` },
    { title: email?.name || 'Unnamed email' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${email?.name || 'Unnamed email'}`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <Tabs value={tab} onChange={(selectedTab) => setTab(selectedTab)} keepMounted={false}>
              <Tabs.List>
                <Tabs.Tab value="clickAnalytics">Click Analytics</Tabs.Tab>
                <Tabs.Tab value="statistics">Statistics</Tabs.Tab>
              </Tabs.List>
              <Tabs.Panel value="clickAnalytics">
                <EmailsClickAnalyticsPage />
              </Tabs.Panel>
              <Tabs.Panel value="statistics">
                <DetailedStatistics name={email?.name} scope="emails" id={emailId} />
              </Tabs.Panel>
            </Tabs>
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default EmailsStatisticsPage;
